// SearchBox component styles
export const SEARCHBOX_STYLES = {
  container: {
    bg: "white",
    borderRadius: "xl",
    border: "1px solid",
    borderColor: "gray.200",
    boxShadow: "sm",
    _hover: {
      borderColor: "blue.300",
      boxShadow: "md"
    },
    _focusWithin: {
      borderColor: "blue.500",
      boxShadow: "0 0 0 1px rgba(59, 130, 246, 0.3)"
    },
    transition: "all 0.2s ease",
    overflow: "hidden"
  },
  input: {
    border: "none",
    _focus: {
      boxShadow: "none",
      border: "none"
    },
    _hover: {
      border: "none"
    },
    fontSize: "14px",
    fontWeight: "500",
    color: "gray.700",
    bg: "transparent",
    px: 4,
    py: 2,
    height: "40px",
    _placeholder: {
      color: "gray.400",
      fontSize: "14px"
    }
  },
  rightElement: {
    height: "40px",
    width: "40px"
  },
  iconButton: {
    base: {
      variant: "ghost",
      size: "sm",
      transition: "all 0.2s ease",
      borderRadius: "lg",
      height: "32px",
      width: "32px",
      minW: "32px"
    },
    search: {
      color: "gray.500",
      _hover: {
        color: "blue.600",
        bg: "blue.50",
        transform: "scale(1.05)"
      },
      _active: {
        transform: "scale(0.95)",
        bg: "blue.100"
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
        _hover: {
          transform: "none",
          bg: "transparent",
          color: "gray.500"
        }
      }
    },
    clear: {
      color: "gray.500",
      _hover: {
        color: "red.600",
        bg: "red.50",
        transform: "scale(1.05)"
      },
      _active: {
        transform: "scale(0.95)",
        bg: "red.100"
      }
    }
  },
  icons: {
    search: { boxSize: 4 },
    close: { boxSize: 3 }
  }
};
